import { call, select, put, takeLatest } from 'redux-saga/effects';

import { selectNetwork } from 'app/dealer/account/Network/selectors';
import { selectLeadsBenchmarkSelectedDate } from '../general/selectors';
import { leadsBenchmarkDataRequestBegin } from '../general/actions';
import { LEADS_BENCHMARK_TRACKING } from '../../tracking'

import { LeadsBenchmarkTimeDivisionActionTypes } from './constants';
import { selectSelectedLeadsBenchmarkTimeDivisionFilter } from './selectors';

/**
 * @function updateDataForTimeDivisionAsync
 * @description
 * updates leads data when time division filter changes
 */

export function* updateDataForTimeDivisionAsync() {
  const selectedTimeDivisionFilter = yield select(
    selectSelectedLeadsBenchmarkTimeDivisionFilter,
  );
  const network = yield select(selectNetwork);
  if (network) {
    yield call(LEADS_BENCHMARK_TRACKING.trackTimeDivisionToggle, {
      network,
      selectedTimeDivisionFilter,
    });
  }

  const leadsBenchmarkSelectedDate = yield select(
    selectLeadsBenchmarkSelectedDate,
  );

  yield put(
    leadsBenchmarkDataRequestBegin({
      data: leadsBenchmarkSelectedDate,
    }),
  );
}

export function* watchTimeDivisionChange() {
  yield takeLatest(
    LeadsBenchmarkTimeDivisionActionTypes.SET_TIME_DIVISION,
    updateDataForTimeDivisionAsync,
  );
}
